import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ServiceCart from "../../serviceCart";
import { ClientModal } from "../../Modals/ClientModal";
import { AllContext } from "../../../context";
import PageLoader from "../../pageLoader";
import PaginationNewUI from "../../PaginationNewUI";
import LoadingOverlay from "react-loading-overlay";
import noData from "../../../assets/img/nodata-img.svg";
import { getBusinessSubdomain } from "../../../shared/functions";
LoadingOverlay.propTypes = undefined;

const TablePublicShop = ({
  isPage,
  searchText,
  isLoadingSearch,
  setIsLoadingSearch,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const context = useContext(AllContext);
  const {
    allApiUrl,
    apiPostMethod,
    toastMessage,
    redirectToLogin,
    apiDeleteMethod,
  } = context;
  const loginUserAccessToken = useSelector(
    (state) => state.loginReducer.loginUserAccessToken
  );
  const { currency } = useSelector(
    (state) => state.sideMenuReducer.paymentSettingData
  );
  const [toggleSideBar, setToggleSidebar] = useState(false);
  const [allServices, setAllServices] = useState([]);
  const [cartCount, setCartCount] = useState(null);
  const [couponCodeAppliedSuccessfully, setCouponCodeAppliedSuccessfully] =
    useState(false);
  const [showCart, setShowCart] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0); // totalRecords
  const [itemOffset, setItemOffset] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [initialLoading, setInitialLoading] = useState(false);

  let header = {
    Authorization: `Bearer ${loginUserAccessToken}`,
  };

  useEffect(() => {
    const getCartItems = localStorage.getItem('cartItems');
    if(getCartItems) {
      const cartData = JSON.parse(getCartItems);
      setCartCount(cartData.length);
    }
  }, []);

  useEffect(() => {
    if (isLoadingSearch) {
      getAllServices();
    }
  }, [isLoadingSearch]);

  
  useEffect(() => {
    getAllServices();
  }, [itemOffset, itemsPerPage]);

  const getAllServices = () => {
    if (!initialLoading) {
      setIsLoading(true);
    }
    let data = {};
    data.page = itemOffset;
    data.limit = itemsPerPage;
    data.businessSubDomain = getBusinessSubdomain()
    if (searchText) {
      data.searchText = searchText;
    }

    apiPostMethod(allApiUrl.PUBLIC_SHOP_LIST_SERVICES, data, header)
      .then((res) => {
        setPageCount(res.data.totalPage);
        setTotalRecordsCount(res.data.totalItems);
        setAllServices([...res.data.services]);
        setInitialLoading(false);
        setIsLoading(false);
        if (setIsLoadingSearch !== undefined) {
          setIsLoadingSearch(false);
        }
      })
      .catch((err) => {
        toastMessage("error", err?.data?.message);
        setInitialLoading(false);
        setIsLoading(false);
        if (setIsLoadingSearch !== undefined) {
          setIsLoadingSearch(false);
        }
    });
  };

  const updateCartCount = (product) => {
    const getCartItems = localStorage.getItem('cartItems');
    if(getCartItems) {
      const cartData = JSON.parse(getCartItems);
      if(cartData.some(data => data.id === product.id)) {
        const productIndex = cartData.findIndex(data => data.id === product.id);
        cartData[productIndex].quantity = cartData[productIndex].quantity + product.quantity;
      } else {
        cartData.push(product);
      }
      setCartCount(cartData.length);
      localStorage.setItem('cartItems', JSON.stringify(cartData));
    } else {
      const cartData = [];
      cartData.push(product);
      localStorage.setItem('cartItems', JSON.stringify(cartData));
      setCartCount(cartData.length);
    }
  }

  return (
    <div>
      <PageLoader isLoading={initialLoading} />
      {!initialLoading && (
        <div
          className={
            true
              ? "shopSection commonPadding horizontalPadding"
              : "shopSection horizontalPadding"
          }
        >
          <div className={isPage ? "commonSlidePl" : ""}>
            <div className={"container-fluid"}>
              <div className="row mb-2">
                <div className="col-lg-6">
                  <div className="heading mb-3">
                    <h2 className="fs-4">Services</h2>
                  </div>
                </div>
                <div className="col-lg-6 d-flex justify-content-end align-items-end">
                  <PaginationNewUI
                    itemsPerPage={itemsPerPage}
                    itemOffset={itemOffset}
                    setItemOffset={setItemOffset}
                    pageCount={pageCount}
                    totalRecordsCount={totalRecordsCount}
                    setItemsPerPage={setItemsPerPage}
                    mainClassName="col-lg-7 d-flex justify-content-end"
                  />
                  <div className="col-lg-3 d-flex justify-content-end">
                    <button
                      className="btn btn-save"
                      onClick={() => {
                        navigate("/public-cart");
                        // document.getElementById("searchModalCloseId").click();
                      }}
                    >
                      View Cart{cartCount ? " | " + cartCount : ""}
                    </button>
                  </div>
                </div>
              </div>

              <LoadingOverlay
                styles={{
                  spinner: (base) => ({
                    ...base,
                    width: "50px",
                    "& svg circle": {
                      stroke: "#007D87",
                    },
                  }),
                  overlay: (base) => ({
                    ...base,
                    background: "rgba(255, 255, 255, 0.5)",
                  }),
                }}
                active={isLoading}
                spinner
                text="Loading content..."
              >
                <div className="row">
                  {allServices.map((service, idx) => {
                    return (
                      <ServiceCart
                        key={idx}
                        {...service}
                        currency={currency}
                        updateCartCount={updateCartCount}
                        setShowCart={setShowCart}
                        setCouponCodeAppliedSuccessfully={
                          setCouponCodeAppliedSuccessfully
                        }
                      />
                    );
                  })}
                  {allServices && allServices.length <= 0 && (
                    <div className="noData-section">
                      <img src={noData} />
                      <p>No Data Found</p>
                    </div>
                  )}
                </div>
              </LoadingOverlay>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};
export default TablePublicShop;